import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import Header from "@/components/Header";
import BottomBar from "@/components/BottomBar";
import { CheckCircle } from "lucide-react";

export default function KycComplete() {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/home");
  };

  return (
    <div className="min-h-screen bg-background">
      <Header showBack={false} />

      <div className="max-w-md mx-auto px-3 pb-20 flex flex-col min-h-[calc(100vh-120px)]">
        <div className="flex-1 flex flex-col items-center justify-center gap-8">
          <div className="w-24 h-24 bg-green-100 dark:bg-green-900/20 rounded-full flex items-center justify-center">
            <CheckCircle className="w-16 h-16 text-green-500" />
          </div>

          <div className="text-center">
            <h1 className="text-2xl font-bold mb-4">Verification Complete!</h1>
            <p className="text-sm text-muted-foreground max-w-xs mx-auto">
              Your identity has been successfully verified. You can now activate
              your card.
            </p>
          </div>
        </div>

        <Button
          onClick={handleGoHome}
          className="w-full h-12 text-base font-semibold"
          size="lg"
        >
          Go to Home
        </Button>

        {/* Progress Indicator */}
        {/* <div className="flex gap-1 justify-center mt-8">
          <div className="w-20 h-2 bg-primary rounded-sm" />
          <div className="w-20 h-2 bg-primary rounded-sm" />
          <div className="w-20 h-2 bg-primary rounded-sm" />
          <div className="w-20 h-2 bg-primary rounded-sm" />
        </div> */}
      </div>

      <BottomBar />
    </div>
  );
}
